import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wuliaoguanli",
  "use": "icon-wuliaoguanli-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-wuliaoguanli\"><path d=\"M509.5 575c-9.2 0-18.5-2.9-26.2-8.6L82.7 359.5c-2.9-1.5-5.6-3.5-7.9-5.8-8.3-8.3-12.9-19.4-12.9-31.1 0-11.8 4.6-22.8 12.9-31.1 2.2-2.2 4.8-4.1 7.6-5.6l401.8-214c15.5-11.7 37.1-11.7 52.7-0.1l400.6 209.9c2.9 1.5 5.5 3.4 7.8 5.7 8.3 8.3 12.9 19.4 12.9 31.1s-4.6 22.8-12.9 31.1c-2.3 2.3-4.9 4.2-7.7 5.7l-401.7 211c-7.9 5.8-17.1 8.7-26.4 8.7zM150.1 322.3l359.3 185.6 360.5-189.3-359.3-188.3-360.5 192z m772.5 4.7zM944.2 666.2L510.1 894.7l-437.4-226c-10.3 12.4-18.8 55.5 3.8 71.1l416.8 215.6c6.8 4.5 25.5 4.5 32.5 0.3L944 736.4c25.5-13.4 13.8-60.8 0.2-70.2zM944.2 473.9L510.1 702.3l-437.4-226c-10.3 12.4-18.8 55.5 3.8 71.1L493.2 763c6.8 4.5 25.5 4.5 32.5 0.3L943.8 544c25.7-13.3 14-60.8 0.4-70.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/wuliaoguanli.svg
// module id = OjQt
// module chunks = 30